import { Brightness as BrightnessIcon } from '../../element/icons';
import { Contrast as ContrastIcon } from '../../element/icons';
import { Blur as BlurIcon } from '../../element/icons';
import { Saturation as HsvIcon } from '../../element/icons/saturation';
import { Temprature as WarmthIcon } from '../../element/icons/tempreture';
import { TOOLS_IDS } from '../../utils/constants';

/** Tools that open a top popup (Draw-style) when clicked */
export const ADJUST_POPUP_TOOL_META = {
  [TOOLS_IDS.BRIGHTNESS]: { titleKey: 'brightnessTool', Icon: BrightnessIcon },
  [TOOLS_IDS.CONTRAST]: { titleKey: 'contrastTool', Icon: ContrastIcon },
  [TOOLS_IDS.HSV]: { titleKey: 'hsvTool', Icon: HsvIcon },
  [TOOLS_IDS.BLUR]: { titleKey: 'blurTool', Icon: BlurIcon },
  [TOOLS_IDS.WARMTH]: { titleKey: 'warmthTool', Icon: WarmthIcon },
};

export const ADJUST_FLIP_TOOL_IDS = new Set([TOOLS_IDS.FLIP_X, TOOLS_IDS.FLIP_Y]);
